import { Typography } from "antd";
import React from "react";

export default function InlineCopyable({ children, text = true }) {
  return <Typography.Text copyable>{children}</Typography.Text>;
}
